<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">到期日期</span>
        <el-date-picker v-model="timevalue" size="small" type="daterange" style="width: 280px;"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker>
        <input-select selectTitle="租赁状态" :selectKey="'leaseStatus'" :selectData="leaseStatusList" @search="search" style="margin: 0 10px;"/>
        <input-select selectTitle="迁出状态" :selectKey="'moveStatus'" :selectData="moveStatusList" @search="search"/>
      </div>
      <input-search placeholder="住户名称/租赁地址" @search="searchKey" />
    </div>

    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @moveOut="moveOut" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />

    <el-dialog title="迁出" :visible.sync="dialogVisible" width="600">
      <form>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">迁出时间：</span>
          </div>
          <el-date-picker v-model="moveTime" type="date" format='yyyy-MM-dd' value-format="yyyy-MM-dd" size="small" style="width: 280px" placeholder="迁出时间"></el-date-picker>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">经办人：</span>
          </div>
          <el-input v-model="manager" size="small" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">备注：</span>
          </div>
          <el-input v-model="memo" size="small" style="width: 280px" />
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="moveBusinessAddress">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/InvestmentLeasing'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'other-contract-management',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '其他合约',
          name: 'other-custom-management'
        }, {
          value: '工商地址注册'
        }],
        pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        timevalue: [],
        tableHead: [{
          prop: 'enterpriseName',
          label: '住户名称'
        }, {
          prop: 'address',
          label: '租赁地址',
        }, {
          prop: 'area',
          label: '面积(m²)'
        }, {
          prop: 'registerTime',
          label: '注册时间'
        }, {
          prop: 'leaseStatusText',
          label: '租赁状态'
        }, {
          prop: 'expireDate',
          label: '到期日期'
        }, {
          prop: 'moveStatusText',
          label: '迁出状态'
        }, {
          prop: 'moveTime',
          label: '迁出时间'
        }, {
          prop: 'manager',
          label: '经办人',
        }, {
          prop: 'memo',
          label: '备注',
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          leaseStatus: '',
          moveStatus: '',
          searchKey: '',
          startTime: '',
          endTime: ''
        },
        operationArr: ['moveOut'],

        leaseStatusList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '0',
            label: '在租'
          }, {
            key: '1',
            label: '退租'
          }
        ],

        moveStatusList: [
          {
            key: '',
            label: '全部'
          }, {
            key: '0',
            label: '未迁出'
          }, {
            key: '1',
            label: '已迁出'
          }
        ],

        dialogVisible: false,
        currentData: {},
        moveTime: '',
        manager: '',
        memo: ''
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      getPage () {
        if (this.timevalue) {
          this.requestData.startTime = this.timevalue[0] || ''
          this.requestData.endTime = this.timevalue[1] || ''
        } else {
          this.requestData.startTime = ''
          this.requestData.endTime = ''
        }
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getBusinessAddressPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                if (v.leaseStatus === '0') {
                  v.leaseStatusText = '在租'
                } else if (v.leaseStatus === '1') {
                  v.leaseStatusText = '退租'
                }
                if (v.moveStatus === '0') {
                  v.moveStatusText = '未迁出'
                } else if (v.moveStatus === '1') {
                  v.moveStatusText = '已迁出'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },

      moveOut (data) {
        for (let i in data) {
          if (data[i] === '--') {
            data[i] = null
          }
        }
        this.currentData = data
        this.manager = ''
        this.memo = ''
        this.moveTime = ''
        this.dialogVisible = true
      },

      // 迁出
      moveBusinessAddress () {
        if (!this.moveTime) {
          nError('请选择迁出时间')
          return false
        }
        if (!this.manager) {
          nError('请输入经办人')
          return false
        }
        let reqData = this.currentData
        reqData.manager = this.manager
        reqData.memo = this.memo
        reqData.moveTime = this.moveTime
        this.$axios.post(api.moveBusinessAddress, reqData)
          .then(res => {
            this.dialogVisible = false
            nSuccess('操作成功')
            this.getPage()
          })
          .catch(errorHandler('操作失败'))
      }
    },
    watch: {
      timevalue (val) {
        this.getPage()
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
  .btn-box {
    .el-date-editor .el-range-separator {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/OtherContracts/BusinessAddressRegistration.vue